import React, { useEffect, useState } from 'react';
import axios from 'axios';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import Container from '@mui/material/Container';
import Pagination from '@mui/material/Pagination';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'quantity', label: '사용권 수량', minWidth: 110, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'createdId', label: '사용자', minWidth: 100, align: 'center' },
  { id: 'createdAt', label: '등록일', minWidth: 180, align: 'center' }
];

export default function CouponUseList(props) {
  const { companyId, orderId, pDatas } = props;
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const getDataList = async (e) => {
    let params = {
      offset,
      page,
      limit: offset,
      orderId
    };

    const response = await axios.get(`/api/coupon/${companyId}`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  useEffect(async () => {
    await getDataList(page);
  }, [page]);

  useEffect(async () => {
    if (companyId) {
      await getDataList(page);
    }
  }, [pDatas?.residualQuantity]);

  return (
    <TableContainer component={'div'}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIdx) => (
            <TableRow hover key={row.id}>
              {columns.map((col, colIdx) => {
                const value = row[col.id];
                return (
                  <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                    {col.format && typeof value === 'number' ? col.format(value) : value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Container maxWidth="sm" sx={{ mt: 2 }}>
        <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
      </Container>
    </TableContainer>
  );
}
